<template>
  <div class="s-footer header-bar mt-10">
    <div class="row">
      <div class="col-xs-12 text-center">
        <p>
          <slot></slot>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 text-center">
        <div class="negotiation-status">
          <slot name="status"></slot>
        </div>
        <div class="slider-notification">
          <slot name="notification"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "s-footer",
  }
</script>

<style scoped>

</style>
